import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Contact from './pages/Contact';
import ImageEnhancerPage from './pages/ImageEnhancerPage';
import ToolsPage from './pages/ToolsPage';
import ScrollToTop from './components/ScrollToTop';
import IntroSplashScreen from './components/IntroSplashScreen';
import './App.css';

function App() {
  return (
    <Router>
      <IntroSplashScreen />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tools" element={<ToolsPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/image-enhancer" element={<ImageEnhancerPage />} />
      </Routes>
    </Router>
  );
}

export default App;
